import { reactLocalStorage } from 'reactjs-localstorage';

import FieldController from '../../controller/FieldController';
import ReportController from '../../controller/ReportController';
import Const from '../../util/Constants';
import Util from '../../util/Util';

class Calculate {
  
  static select = (xModel, yModel, x, y, z, filters, data) => {
    const models = reactLocalStorage.getObject(Const.Model);
    const model = models[yModel];

    const header = [model.fields[y].label_name, 'Count'];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [ user.user_id, ...user.child];
    const Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
    
    let yOptions = FieldController.getOptions(model.fields[y], undefined, true);
    if(Restrict && model.fields[y].field_type.includes('~user')) {
      yOptions = yOptions.filter(opt =>
        children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }

    let filter = filters.find(filter => filter.field === model.fields[y].field_key);
    if(filter) yOptions = yOptions.filter(opt =>
      filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    this.yOptions = yOptions;

    const rows = yOptions.map(option => option.label);
    const body = [];
    let total = 0;
    for(let i = 0; i < rows.length; i++) {
      const yVal = yOptions[i].value;
      const isMultiSelect = model.fields[y].field_type.includes(Const.MultiSelect);
      let tmp = null;
      if(isMultiSelect) { tmp = data.filter(itm => itm[y] && itm[y].includes(`~${yVal}~`)); }
      else { tmp = data.filter(item => item[y] === yVal); }
      let count = 0;
      for(let k = 0; k < tmp.length; k++) { count += tmp[k].sum; }
      total += count;
      body.push([rows[i], count]);
    }
    const footer = ['Total', total];
    return [ header, ...body, footer ];
  }

  static select2Select = (xModelName, yModelName, x, y, z, filters, data) => {
    const models = reactLocalStorage.getObject(Const.Model);
    const xModel = models[xModelName];
    const yModel = models[yModelName];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [ user.user_id, ...user.child];
    const Restrict = Util.isAllow(xModel.permission, Const.PermRestricAcc);

    let xOptions = FieldController.getOptions(xModel.fields[x], undefined, true);
    if(Restrict && xModel.fields[x].field_type.includes('~user')) {
      xOptions = xOptions.filter(opt => 
        children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter = filters.find(filter => filter.field === xModel.fields[x].field_key);
    if(filter) {
      xOptions = xOptions.filter(opt => filter.value.includes(`~${opt.value}~`));
    }

    const header = [ '', ...xOptions.map(option => option.label), 'Total'];
    const footer = [ 'Total', ...xOptions.map(i => 0), 0];

    let yOptions = FieldController.getOptions(yModel.fields[y], undefined, true);
    if(this.restrict && yModel.fields[y].field_type.includes('~user')) {
      yOptions = yOptions.filter(opt =>
        children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    filter = filters.find(filter => filter.field === yModel.fields[y].field_key);
    if(filter) yOptions = yOptions.filter(opt => 
      filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));

    const xType = xModel.fields[x].field_type.includes(Const.MultiSelect);
    const yType = yModel.fields[y].field_type.includes(Const.MultiSelect);

    const rows = yOptions.map(option => option.label);
    const body = [];
    for(let i = 0; i < rows.length; i++) {
      const yVal = yOptions[i].value;
      let row = [rows[i]];
      let total = 0;
      for(let j = 0; j < xOptions.length; j++) {
        const xVal = xOptions[j].value;
        let tmp = [];
        if(!xType && !yType) {
          tmp = data.filter(item => item[x] === xVal && item[y] === yVal);
        } else if(xType && !yType) {
          tmp = data.filter(item => item[x].includes(`~${xVal}~`) && item[y] === yVal);
        } else if(!xType && yType) {
          tmp = data.filter(item => item[x] === xVal && item[y].includes(`~${yVal}~`));
        } else {
          tmp = data.filter(itm => itm[x].includes(`~${xVal}~`)
            && itm[y].includes(`~${yVal}~`));
        }
        let count = 0;
        if(tmp.length > 0) {
          if(z && z.includes(Const.Opt)) {
            for(let k = 0; k < tmp.length; k++) {
              const items = tmp[k][y].length > 2 ? tmp[k][y].substring(1, tmp[k][y].length - 1).split(Const.Opt) : [];
              const itemCounts = tmp[k].sum.length > 2 
                ? tmp[k].sum.substring(1, tmp[k].sum.length - 1).split(Const.Opt) : [];
              for(let l = 0; l < items.length; l++) {
                if(parseInt(items[l]) === yVal) { count += parseInt(itemCounts[l]); }
              }
            }
          } else { for(let k = 0; k < tmp.length; k++) count += tmp[k].sum; }
        }
        row.push(count);
        total += count;
        footer[j + 1] += count;
      }
      row.push(total);
      body.push(row);
      footer[footer.length - 1] += total;
    }

    return [ header, ...body, footer];
  }

  static selectToMonth = (xModelName, yModelName, x, y, z, filters, data) => {
    const models = reactLocalStorage.getObject(Const.Model);
    const xModel = models[xModelName];
    const yModel = models[yModelName];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [ user.user_id, ...user.child];
    const Restrict = Util.isAllow(xModel.permission, Const.PermRestricAcc);
    
    let xOptions = ReportController.getOptions(xModel.fields[x], true);
    if(Restrict && xModel.fields[x].field_type.includes('~user')) {
      xOptions = xOptions.filter(opt => children.find(child => 
        parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter = filters.find(filter => filter.field === xModel.fields[x].field_key);
    if(filter) {
      xOptions = xOptions.filter(opt => 
        filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    }
    const xType = xModel.fields[x].field_type.includes(Const.MultiSelect);

    const header = [ '', ...xOptions.map(option => option.label), 'Total'];
    const footer = [ 'Total', ...xOptions.map(i => 0), 0];

    let yOpts = ReportController.getHeaderMonth(filters, yModel.fields[y]);
    const rows = yOpts.map(option => option.label);
    
    const body = [];
    for(let i = 0; i < yOpts.length; i++) {
      let row = [rows[i], ...xOptions.map(i => 0), 0];
      const yData = data.filter(data => ReportController.isIn(yOpts[i].value, data[y]));
      for(let j = 0; j < xOptions.length; j++) {
        let rData = [];
        if(xType) { rData = yData.filter(data => data[x].includes(`~${xOptions[j].value}~`)); }
        else { rData = yData.filter(data => data[x] === xOptions[j].value); }
        let total = 0;
        for(let k = 0; k < rData.length; k++) { 
          if(typeof rData[k][z] === 'string') {
            if(typeof rData[k][x] === 'string' && rData[k][x].length > 2) {
              const tmpOpt = rData[k][x].substring(1, rData[k][x].length).split(Const.Opt);
              const tmpValue = rData[k][z].substring(1, rData[k][z].length).split(Const.Opt);
              for(let m = 0; m < tmpOpt.length; m++) {
                if(parseInt(tmpOpt[m]) === xOptions[j].value) {
                  total += parseInt(tmpValue[m]);
                }
              }
            }
          } else {
            total += rData[k][z];
          }
        }
        row[j + 1] = total;
      }

      let total = 0;
      for(let j = 1; j < row.length - 1; j++) {
        total += row[j];
        footer[j] += row[j];
      }
      row[row.length - 1] = total;
      footer[footer.length - 1] += total;
      body.push(row);
    }
    return [ header, ...body, footer];
  }

  static selectToDay = (modelName, x, y, z, filters, data) => {
    const models = reactLocalStorage.getObject(Const.Model);
    const model = models[modelName];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [ user.user_id, ...user.child];
    const Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
    
    let xOptions = ReportController.getOptions(model.fields[x], true);
    if(Restrict && model.fields[x].field_type.includes('~user')) {
      xOptions = xOptions.filter(opt => children.find(child => 
        parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter = filters.find(filter => filter.field === model.fields[x].field_key);
    if(filter) {
      xOptions = xOptions.filter(opt => 
        filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    }
    const xType = model.fields[x].field_type.includes(Const.MultiSelect);

    const header = [ '', ...xOptions.map(option => option.label), 'Total'];
    const footer = [ 'Total', ...xOptions.map(i => 0), 0];

    let yOpts = ReportController.getHeaderDay(filters, model.fields[y]);
    const rows = yOpts.map(option => option.label);
    
    const body = [];
    for(let i = 0; i < yOpts.length; i++) {
      let row = [rows[i], ...xOptions.map(i => 0), 0];
      const yData = data.filter(data => ReportController.isIn(yOpts[i].value, data[y]));
      for(let j = 0; j < xOptions.length; j++) {
        let rData = [];
        if(xType) { rData = yData.filter(data => data[x].includes(`~${xOptions[j].value}~`)); }
        else { rData = yData.filter(data => data[x] === xOptions[j].value); }
        let total = 0;
        for(let k = 0; k < rData.length; k++) { 
          if(typeof rData[k][z] === 'string') {
            if(typeof rData[k][x] === 'string' && rData[k][x].length > 2) {
              const tmpOpt = rData[k][x].substring(1, rData[k][x].length).split(Const.Opt);
              const tmpValue = rData[k][z].substring(1, rData[k][z].length).split(Const.Opt);
              for(let m = 0; m < tmpOpt.length; m++) {
                if(parseInt(tmpOpt[m]) === xOptions[j].value) {
                  total += parseInt(tmpValue[m]);
                }
              }
            }
          } else if(z === 'id'){
            total += 1;
          } else if(z === 'id'){
            total += rData[k][z];
          }
        }
        row[j + 1] = total;
      }

      let total = 0;
      for(let j = 1; j < row.length - 1; j++) {
        total += row[j];
        footer[j] += row[j];
      }
      row[row.length - 1] = total;
      footer[footer.length - 1] += total;
      body.push(row);
    }
    return [ header, ...body, footer];
  }

  static selectToHr = (xModel, yModel, x, y, z, filters, data) => {
    const models = reactLocalStorage.getObject(Const.Model);
    const model = models[xModel];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [ user.user_id, ...user.child];
    const Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
    
    let xOptions;
    let xType;
    if(x) {
      xOptions = ReportController.getOptions(model.fields[x], true);
      if(Restrict && model.fields[x].field_type.includes('~user')) {
        xOptions = xOptions.filter(opt => children.find(child => 
          parseInt(child) === parseInt(opt.value)) !== undefined);
      }
      let filter = filters.find(filter => filter.field === model.fields[x].field_key);
      if(filter) {
        xOptions = xOptions.filter(opt => 
          filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
      }
      xType = model.fields[x].field_type.includes(Const.MultiSelect);
    }

    let header, footer;
    if(x) {
      header = [ '', ...xOptions.map(option => option.label), 'Total'];
      footer = [ 'Total', ...xOptions.map(i => 0), 0];
    } else {
      header = [ '', 'Total'];
      footer = [ 'Total', 0];
    }

    let yOpts = ReportController.getHeaderHrs(filters, model.fields[y]);
    const rows = yOpts.map(option => option.label);
    
    const isCount = z && z.length > 0 && z !== 'duration';
    
    const body = [];
    for(let i = 0; i < yOpts.length; i++) {
      if(x) {
        let row = [rows[i], ...xOptions.map(i => 0), 0];
        const yData = data.filter(data => ReportController.isIn(yOpts[i].value, data[y]));
        for(let j = 0; j < xOptions.length; j++) {
          let rData = [];
          if(xType) { rData = yData.filter(data => data[x].includes(`~${xOptions[j].value}~`)); }
          else {  rData = yData.filter(data => data[x] === xOptions[j].value); }
          let total = 0;
          if(isCount) {
            for(let k = 0; k < rData.length; k++) { 
              if(typeof rData[k][z] === 'string') {
                if(typeof rData[k][x] === 'string' && rData[k][x].length > 2) {
                  const tmpOpt = rData[k][x].substring(1, rData[k][x].length).split(Const.Opt);
                  const tmpValue = rData[k][z].substring(1, rData[k][z].length).split(Const.Opt);
                  for(let m = 0; m < tmpOpt.length; m++) {
                    if(parseInt(tmpOpt[m]) === xOptions[j].value) {
                      total += parseInt(tmpValue[m]);
                    }
                  }
                }
              } else {
                total += rData[k][z];
              }
            }
          } else {
            total = rData.length;
          }
          row[j + 1] = total;
        }

        let total = 0;
        for(let j = 1; j < row.length - 1; j++) {
          total += row[j];
          footer[j] += row[j];
        }
        row[row.length - 1] = total;
        footer[footer.length - 1] += total;
        body.push(row);
      } else {
        let total = 0;
        const items = data.filter(data => ReportController.isIn(yOpts[i].value, data[y]));
        if(items.length > 0) {
          for(let k = 0; k < items.length; k++) {
            total = total + parseInt(items[k][z])
          }
        }
        footer[footer.length - 1] += total;
        body.push([rows[i], total]);
      }
    }
    return [ header, ...body, footer];
  }

  static target = (modelName, x, y, z, filters, data) => {
    const models = reactLocalStorage.getObject(Const.Model);
    const model = models[modelName];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [ user.user_id, ...user.child];
    const Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
    
    let xOptions = ReportController.getOptions(model.fields[x], true);
    if(Restrict && model.fields[x].field_type.includes('~user')) {
      xOptions = xOptions.filter(opt => children.find(child => 
        parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter = filters.find(filter => filter.field === model.fields[x].field_key);
    if(filter) {
      xOptions = xOptions.filter(opt => 
        filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    }
    const xType = model.fields[x].field_type.includes(Const.MultiSelect);

    const header = [ '', ...xOptions.map(option => option.label), 'Total'];
    const footer = [ 'Total', ...xOptions.map(i => 0), 0];

    let yOpts = ReportController.getHeaderMonth(filters, model.fields[y]);
    const rows = yOpts.map(option => option.label);
    
    const body = [];
    for(let i = 0; i < yOpts.length; i++) {
      let row = [rows[i], ...xOptions.map(i => 0), 0];
      const yData = data.filter(data => ReportController.isIn(yOpts[i].value, data[y]));
      for(let j = 0; j < xOptions.length; j++) {
        let rData = [];
        if(xType) { rData = yData.filter(data => data[x].includes(`~${xOptions[j].value}~`)); }
        else { rData = yData.filter(data => data[x] === xOptions[j].value); }
        let total = 0;
        for(let k = 0; k < rData.length; k++) { 
          if(typeof rData[k][z] === 'string') {
            if(typeof rData[k][x] === 'string' && rData[k][x].length > 2) {
              const tmpOpt = rData[k][x].substring(1, rData[k][x].length).split(Const.Opt);
              const tmpValue = rData[k][z].substring(1, rData[k][z].length).split(Const.Opt);
              for(let m = 0; m < tmpOpt.length; m++) {
                if(parseInt(tmpOpt[m]) === xOptions[j].value) {
                  total += parseInt(tmpValue[m]);
                }
              }
            }
          } else {
            total += rData[k][z];
          }
        }
        row[j + 1] = total;
      }

      let total = 0;
      for(let j = 1; j < row.length - 1; j++) {
        total += row[j];
        footer[j] += row[j];
      }
      row[row.length - 1] = total;
      footer[footer.length - 1] += total;
      body.push(row);
    }
    return [ header, ...body, footer];
  }
}
export default Calculate;